module.exports = __webpack_public_path__ + "static/woman-puzzle.454b12a8.jpg";